import { newsletterPostQueries } from "@circle-react/lib/queries/newsletterPosts";
import { newsletterQueries } from "@circle-react/lib/queries/newsletters";
import type {
  NewsletterPost,
  NewsletterPostStatus,
} from "@circle-react/types/Newsletter";
import type { QueryClient } from "react-query";

import { isPositiveInt } from "@/react/helpers/number";

const editableStatuses: NewsletterPostStatus[] = ["draft", "published"];

export const isPostEditable = (post: Pick<NewsletterPost, "status">) =>
  editableStatuses.includes(post.status);

export const fetchNewsletterPost = async (
  queryClient: QueryClient,
  id: string,
): Promise<NewsletterPost | undefined> => {
  const postId = Number(id);
  if (!isPositiveInt(postId)) return undefined;

  const newsletters = await queryClient.ensureQueryData(
    newsletterQueries.list(),
  );

  const newsletterId = newsletters[0]?.id;
  if (!newsletterId) return undefined;

  return queryClient.fetchQuery(
    newsletterPostQueries.detail(newsletterId, postId),
  );
};
